import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { GiftCard, Tag } from '@azoya-spa/ui'
import '@azoya-spa/ui/styles.css'
import './PlanityGift.css'
import { useBookingSettings } from '../../../hooks/useBookingSettings'
import { useSiteContent } from '../../../hooks/useSiteContent'
import practicalInfoFallback from '../../../api/fallback/practicalInfo.json'
import { frenchNumberToTelHref } from '../../../utils/phone'
import { phoneClicked } from '../../../analytics/events'
import { PlanityWidgetLoading, PlanityWidgetUnavailable } from '../PlanityWidgetStatus'

export default function PlanityGift() {
    const { booking, status: bookingStatus } = useBookingSettings()
    const info = useSiteContent('practical-info', practicalInfoFallback)
    const widgetInjectedRef = useRef(false)


    useEffect(() => {
        // bookingStatus !== 'ready' : cf. useBookingSettings — n'injecte que
        // lorsque la vraie clé est confirmée reçue de l'API. Le widget ne
        // doit être injecté qu'une seule fois, quoi qu'il arrive ensuite :
        // une deuxième injection dupliquerait ses balises <script>.
        if (bookingStatus !== 'ready' || widgetInjectedRef.current) return;
        const container = document.getElementById('planityContainer');
        if (!container) return;
        widgetInjectedRef.current = true;

        window.planity = {
            key: booking.planityWidgetKey,
            primaryColor: '#264653',
            options: {
                headerWidth: '100px'
            },
            giftVoucherContainer: container
        };

        const script = document.createElement('script');
        script.src = "https://d2skjte8udjqxw.cloudfront.net/widget/production/polyfills.latest.js";
        script.async = true;
        container.appendChild(script);

        const script2 = document.createElement('script');
        script2.src = "https://d2skjte8udjqxw.cloudfront.net/widget/production/app.latest.js";
        script2.async = true;
        container.appendChild(script2);

    }, [bookingStatus, booking])

    return (
        <div className='PlanityGift'>
            {/* La visiteuse arrive souvent du lien « Vous souhaitez offrir ? »
                de Réserver en ligne : elle a lu une promesse de cartes cadeaux,
                elle doit lire une phrase d'accueil avant tout widget tiers. */}
            <div className='PlanityGift-accroche'>
                <div className='PlanityGift-texte'>
                    <Tag variant="primary">Cartes cadeaux</Tag>
                    <h1>Offrir un moment chez Azoya Spa</h1>
                    <p>
                        Choisissez un montant ou un soin précis. La carte est valable un an sur
                        l’ensemble de nos prestations, envoyée par e-mail dans la minute ou à
                        retirer à l’institut, à Auxerre.
                    </p>
                    <p className='PlanityGift-precision'>
                        Le paiement et l’envoi sont gérés par Planity, notre plateforme de
                        réservation.
                    </p>
                </div>
                {/* GiftCard rend recto et verso à dimensions fixes, conçus pour
                    être côte à côte et non empilés. */}
                <div className='PlanityGift-cartes'>
                    <GiftCard face="front" amount="120€" tagline="Auxerre · depuis 2014" />
                    <GiftCard face="back" validUntil="07 / 2027" serial="N° AZ-2026-000903" />
                </div>
            </div>

            <div className='PlanityGift-panneau'>
                <div className='PlanityGift-panneau-entete'>
                    <div className='PlanityGift-panneau-titre'>Votre carte cadeau Azoya Spa</div>
                    <Link className='PlanityGift-lien-offres' to="/offres-abonnement">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e86f51" strokeWidth="2" aria-hidden="true">
                            <path d="M19 12H5M11 6l-6 6 6 6" />
                        </svg>
                        Voir les offres et abonnements
                    </Link>
                </div>

                <div className='planity' id='planityContainer'>
                    {bookingStatus === 'unavailable' ? (
                        <PlanityWidgetUnavailable planityUrl={booking.planityPublicUrl} contexte="cadeau" />
                    ) : (
                        <PlanityWidgetLoading contexte="cadeau" />
                    )}
                </div>
            </div>

            {/* La décision 7 du cahier des charges — /offrir n'émet rien de plus
                que son `$pageview` — porte sur `gift_card_opened` et le risque de
                compter deux fois un accès à la carte cadeau. Un appel n'est pas un
                accès à la carte cadeau : ce lien reçoit `phone_clicked`, comme les
                deux liens de PlanityWidgetUnavailable que cette page monte déjà. */}
            <div className='PlanityGift-pied'>
                <span>Une question sur une carte cadeau ?</span>
                <a href={frenchNumberToTelHref(info.phone)} onClick={() => phoneClicked()}>{info.phone}</a>
            </div>
        </div>
    )
}
